import {
    Dumbbell,
    Leaf,
    Brain,
    LayoutList,
    Heart,
    Infinity as InfIcon,
} from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [Dumbbell, Leaf, Brain, LayoutList, Heart, InfIcon];

const Benefits = () => {
    const { t } = useLanguage();
    return (
        <section id="benefits" data-testid="benefits-section" className="py-24 md:py-32 bg-ella-cream">
            <div className="ella-container">
                <div className="text-center max-w-2xl mx-auto">
                    <span className="ella-overline" data-testid="benefits-overline">{t.benefits.overline}</span>
                    <h2 className="ella-headline text-4xl md:text-5xl lg:text-6xl mt-4 text-ella-ink" data-testid="benefits-title">{t.benefits.title}</h2>
                    <p className="mt-6 text-lg text-ella-ink/70 font-light">{t.benefits.subtitle}</p>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {t.benefits.items.map((item, i) => {
                        const Icon = ICONS[i % ICONS.length];
                        return (
                            <div key={i} data-testid={`benefit-${i}`} className="group p-8 md:p-10 rounded-3xl border border-ella-line bg-white hover:border-ella-gold/60 transition-all duration-500">
                                <div className="flex items-center gap-4">
                                    <span className="w-12 h-12 rounded-full border border-ella-gold/40 bg-ella-sand flex items-center justify-center text-ella-gold-dark group-hover:bg-ella-ink group-hover:text-ella-gold group-hover:border-ella-ink transition-all duration-500">
                                        <Icon className="w-5 h-5" strokeWidth={1.4} />
                                    </span>
                                    <span className="font-display text-xs text-ella-muted tracking-[0.3em]">0{i + 1}</span>
                                </div>
                                <h3 className="font-display text-2xl md:text-[26px] mt-6 text-ella-ink leading-tight">{item.title}</h3>
                                <p className="mt-4 text-ella-ink/70 leading-relaxed font-light text-[15px]">{item.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Benefits;
